// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.auth-dp label.form-label[data-v-b89ca3de] {\n  color: var(--bluey-grey);\n  font-size: 0.92rem;\n}\n.login-route-link[data-v-b89ca3de] {\n  color: var(--bluey-grey);\n}\n.login-route-link[data-v-b89ca3de]:hover {\n  text-decoration: underline;\n  color: var(--sea);\n}\n", ""]);
// Exports
module.exports = exports;
